/* eslint-disable prettier/prettier */


import type { Geoblock } from "@/models/Geoblock"

export const EFFECTS = {
  Allow: 'Allow',
  Deny: 'Block',
}

export const EFFECT_OPTIONS = [
  {
    value: 'Allow',
    label: 'Allow',
    defaultLabel: 'Block Selected Locations',
    helpText: (
      <>
        <strong>Content is available everywhere</ strong > except locations you explicitly block.
      </>
    ),
    ruleBuilderHelp: 'Adding locations where content is allowed'
  },
  {
    value: 'Deny',
    label: 'Block',
    defaultLabel: 'Allow Selected Locations',
    helpText: (
      <>
        <strong>Content is blocked everywhere </strong> except locations you explicitly allow.
      </>
    ),
    ruleBuilderHelp: 'Adding locations where content is blocked'
  },
];

export const GEOGRAPHY_LEVELS: Record<string, { singular: string; plural: string }> = {
  Country: { singular: 'Country', plural: 'Countries' },
  Subdivision: { singular: 'Region / State', plural: 'Regions / States' },
  Dma: { singular: 'DMA', plural: 'DMAs' },
  City: { singular: 'City', plural: 'Cities' },
  PostalCode: { singular: 'Zip / Postal Code', plural: 'Zip / Postal Codes' },
};

export const GEOGRAPHY_LEVEL_OPTIONS = Object.entries(GEOGRAPHY_LEVELS).map(([value, labels]) => ({
  value,
  label: labels.singular,
}));

export const EMPTY_GEOBLOCK: Geoblock = {
  defaultEffect: 'Allow',
  rules: [
    { effect: 'Allow', type: 'Country', values: [] },
    { effect: 'Deny', type: 'Country', values: [] },
    { effect: 'Allow', type: 'Subdivision', values: [] },
    { effect: 'Deny', type: 'Subdivision', values: [] },
    { effect: 'Allow', type: 'Dma', values: [] },
    { effect: 'Deny', type: 'Dma', values: [] },
    { effect: 'Allow', type: 'City', values: [] },
    { effect: 'Deny', type: 'City', values: [] },
    { effect: 'Allow', type: 'PostalCode', values: [] },
    { effect: 'Deny', type: 'PostalCode', values: [] },
  ],
};
